import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d82d103"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex gap-6 align-items-center mb-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: "btn btn-danger btn-sm",
  disabled: ""
}
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "gap-6 align-items-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "ms-8 btn btn-danger btn-sm",
  disabled: ""
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mt-2 mb-6" }
const _hoisted_13 = ["onClick", "disabled"]

import { ref } from "vue";
import i18n from "@/core/plugins/i18n";
import AccountService from "../../../accounts/services/AccountService";
import { ElNotification } from "element-plus";
import { useStore } from "@/store";
import { isMobile } from "@/core/config/WindowConfig";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditAlias',
  emits: ["update"],
  setup(__props, { expose: __expose, emit: emits }) {

const store = useStore();
const defaultSalesAccount = ref(
  store.state.AuthModule.user?.defaultSalesAccount
);

const t = i18n.global.t;
const title = ref(t("title.updateAccountSettings"));
const isLoading = ref(false);
const centerDialogVisible = ref(false);
const accounts = ref(<any>[]);


const updateDefaultAccount = async (item: any) => {
  isLoading.value = true;
  try {
    await AccountService.updateDefaultSalesAccount(item.uid).then(() => {
      ElNotification({
        title: t("status.success"),
        type: "success",
      });
      accounts.value.forEach((account: any) => {
        account.isDefault = account.uid == item.uid;
      });
      defaultSalesAccount.value = item.uid;
      emits("update");
    });
  } catch (error) {
    ElNotification({
      title: t("error.__UPDATE_FAILED__"),
      type: "error",
    });
    console.error(error);
  }

  isLoading.value = false;
};

const updateAlias = async (item: any) => {
  isLoading.value = true;
  try {
    await AccountService.updateAlias({
      uid: item.uid,
      alias: item.alias,
    }).then(() => {
      ElNotification({
        title: t("status.success"),
        type: "success",
      });
      emits("update");
    });
  } catch (error) {
    ElNotification({
      title: t("error.__UPDATE_FAILED__"),
      type: "error",
    });
    console.error(error);
  }

  isLoading.value = false;
};
const show = (_accounts: any) => {
  centerDialogVisible.value = true;
  if (_accounts.length > 1) {
    accounts.value = _accounts.map((account: any) => ({
      ...account,
      isDefault: defaultSalesAccount.value == account.uid,
    }));
  } else {
    accounts.value = [{ ..._accounts }];
  }
};
const hide = () => {
  centerDialogVisible.value = false;
  accounts.value = [];
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: centerDialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((centerDialogVisible).value = $event)),
    title: title.value,
    width: "650",
    "align-center": "",
    "before-close": hide
  }, {
    default: _withCtx(() => [
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(item.uid), 1),
                    (item?.siteId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.$t("type.siteType." + item.siteId)) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: item.alias,
                    "onUpdate:modelValue": ($event: any) => ((item.alias) = $event),
                    placeholder: "Please enter the alias",
                    style: {"width":"200px"},
                    clearable: "",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm",
                    onClick: ($event: any) => (updateAlias(item)),
                    disabled: isLoading.value
                  }, _toDisplayString(_ctx.$t("action.updateAlias")), 9, _hoisted_4),
                  (item.isDefault)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_5, _toDisplayString(_ctx.$t("status.default")), 1))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-success btn-sm",
                        disabled: isLoading.value,
                        onClick: ($event: any) => (updateDefaultAccount(item))
                      }, _toDisplayString(_ctx.$t("action.setDefault")), 9, _hoisted_6))
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "border_bottom"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(item.uid), 1),
                  (item?.siteId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(_ctx.$t("type.siteType." + item.siteId)) + ")", 1))
                    : _createCommentVNode("", true),
                  (item.isDefault)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_10, _toDisplayString(_ctx.$t("status.default")), 1))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "ms-8 btn btn-success btn-sm",
                        onClick: ($event: any) => (updateDefaultAccount(item))
                      }, _toDisplayString(_ctx.$t("action.setDefault")), 9, _hoisted_11))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_input, {
                    modelValue: item.alias,
                    "onUpdate:modelValue": ($event: any) => ((item.alias) = $event),
                    placeholder: "Please enter the alias",
                    style: {"width":"110px"},
                    clearable: "",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  _createElementVNode("button", {
                    class: "ms-4 btn btn-primary btn-sm",
                    onClick: ($event: any) => (updateAlias(item)),
                    disabled: isLoading.value
                  }, _toDisplayString(_ctx.$t("action.updateAlias")), 9, _hoisted_13)
                ])
              ]))
            }), 128))
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})